/**
 * usuarios.service.ts — CRUD de /usuarios (admin-only). Único acceso al API.
 */
import { httpGet, httpPost, httpPatch } from "@/shared/lib/http-client.js";
import type { CambiosUsuarioInput, NuevoUsuarioInput, Usuario } from "../types.js";

export async function listUsuarios(): Promise<Usuario[]> {
  return httpGet<Usuario[]>("/usuarios");
}

export async function createUsuario(input: NuevoUsuarioInput): Promise<Usuario> {
  return httpPost<Usuario>("/usuarios", input);
}

export async function updateUsuario(id: string, cambios: CambiosUsuarioInput): Promise<Usuario> {
  return httpPatch<Usuario>(`/usuarios/${id}`, cambios);
}
